import React from "react";
import PulseLoader from "react-spinners/PulseLoader";
import tyre from "../../../assets/images/tyre.png";
import styles from "./style.module.scss";

export default function Loading() {
  return (
    <div className={styles.loadingContainer}>
      <img src={tyre} className={styles.loadingTyre} alt="Tyre" />
      <PulseLoader
        color="white"
        size={25}
        speedMultiplier={0.8}
        margin={25}
      ></PulseLoader>
    </div>
  );
}
